<template>
    <!-- Titulo de pagina no padrao do site: etiqueta, titulo com a parte em lilas e subtitulo opcional -->
    <header class="page-title" :class="{ 'page-title--light': light }">
        <span v-if="eyebrow" class="page-title__eyebrow">
            <v-icon small :color="light ? 'white' : 'primary'">{{ icon }}</v-icon> {{ eyebrow }}
        </span>
        <h1 class="page-title__h1">{{ title }}<span v-if="highlight" class="page-title__highlight">{{ highlight }}</span></h1>
        <p v-if="subtitle" class="page-title__subtitle">{{ subtitle }}</p>
    </header>
</template>

<script>
export default {
    name: "PageTitle",

    props: {
        // Texto pequeno acima do titulo (ex.: "ÁREA DO CREDOR").
        eyebrow: { type: String, default: "" },
        icon: { type: String, default: "mdi-circle-small" },
        title: { type: String, required: true },
        // Parte final do titulo, em lilas.
        highlight: { type: String, default: "" },
        subtitle: { type: String, default: "" },
        // Para fundo colorido (texto claro).
        light: { type: Boolean, default: false },
    },
};
</script>

<style scoped>
.page-title {
    padding: 32px 0 24px;
}

.page-title__eyebrow {
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.12em;
    color: #766386;
}

.page-title__h1 {
    margin: 14px 0 0;
    font-size: clamp(28px, 3.4vw, 40px);
    font-weight: 700;
    color: #25113c;
    letter-spacing: -0.035em;
    line-height: 1.2;
    overflow-wrap: anywhere;
}

.page-title__h1 .page-title__highlight {
    margin-left: 0.25em;
    color: #806697;
}

.page-title__subtitle {
    margin: 10px 0 0;
    color: #73677c;
    font-size: 14px;
}

.page-title--light .page-title__eyebrow,
.page-title--light .page-title__subtitle {
    color: rgba(255, 255, 255, 0.85);
}

.page-title--light .page-title__h1 {
    color: #fff;
}

.page-title--light .page-title__h1 .page-title__highlight {
    color: #25113c;
}
</style>
